import { RegularBenefitVariant } from '../../../../../../../typings'

export const EMPTY_MAX_PRICE = {
  type: RegularBenefitVariant.MaxPrice as const,
  value: undefined,
}
